module.exports = __webpack_public_path__ + "static/media/learning-content-blur.38dc9810.png";